import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Bubble, InlinePreloader } from 'ctia-ui';
import Logo from 'containers/Logo';
import Maintenance from 'containers/Maintenance';
import { loginCauseway, getUserInfo } from 'actions/user';
import { getSystemInfo } from 'actions/system';
import { cbrsSupportEmail } from 'helpers/Emails';
import { getTicket } from 'helpers/ArgsHelper';
import { uri, casUrl } from 'dictionaries/Env';
import { getSession } from 'libs/sessionStorage';

class CAS extends Component {
  constructor(props) {
    super(props);

    this.ticket = getTicket(this.props.location);

    this.state = {
      accessError: false
    };
  }

  componentDidMount() {
    this.props.getSystemInfo();
    this.checkTicket();
  }

  componentWillReceiveProps(nextProps) {
    return window.location = "/home";

    if (
      nextProps.system &&
      !nextProps.system.serverIsDown &&
      this.ticket === undefined
    ) {
      return (window.location = `${casUrl}?service=${uri}`);
    }

    // reset error
    if (nextProps.user !== null) {
      this.setState({ accessError: false });
    }

    // hide preloader if access error occurred
    if (nextProps.user && nextProps.user.accessError) {
      return this.restrictAccess();
    }

    const sessionUser = getSession('user');
    if (sessionUser && this.ticket !== undefined) {
      // trick to prevent rendering home page between redirecting action
      setTimeout(() => this.props.history.push('/home'), 500);
    }
  }

  restrictAccess = () => this.setState({ accessError: true });

  checkTicket = () => {
    if (this.ticket) {
      this.props.loginCauseway(
        this.ticket,
        this.props.getUserInfo,
        this.restrictAccess
      );
    }
  };

  renderPreloader = () => {
    if (this.state.accessError) return null;
    return (
      <div className="text-center">
        {this.state.accessError ? (
          this.renderAccessError()
        ) : (
          <InlinePreloader show={true} />
        )}
      </div>
    );
  };

  renderAccessError = () => {
    if (this.state.accessError) {
      return (
        <Bubble show={true} type="danger" icon="remove">
          Your credentials don't allow you to use this database. Please,{' '}
          <a href={`mailto:${cbrsSupportEmail}`}>contact us</a> if you have any
          questions. <Link to="/home">Return to home page &rarr;</Link>
        </Bubble>
      );
    }
  };

  render() {
    const { system } = this.props;

    // show maintenance page if server is off
    if (system && system.serverIsDown) {
      return <Maintenance />;
    }

    return (
      <div>
        <div className="block-logo-middle">
          <Logo />
          {this.renderPreloader()}
        </div>
        {this.renderAccessError()}
      </div>
    );
  }
}

function mapStateToProps({ user, system }) {
  return { user, system };
}

export default connect(
  mapStateToProps,
  { loginCauseway, getSystemInfo, getUserInfo }
)(CAS);



// WEBPACK FOOTER //
// ./src/containers/CAS.js